import React from 'react';
import { useFormikContext } from 'formik';
import { Typography, Grid, Divider } from '@mui/material';
import ProductDetails from './ProductDetails';
import ShippingDetails from './ShippingDetails';
import PaymentDetails from './PaymentDetails';
import AddressDetails from './AddressDetails';

export default function ReviewOrder(props) {
  // const { values: formValues } = useFormikContext();
  const { rhf } = props;
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        สรุปข้อมูลประกอบการจ้าง
      </Typography>
      <Divider sx={{ mb: 3 }} />
      {/* <ProductDetails /> */}
      {/* <Grid container spacing={2}>
        <ShippingDetails formValues={formValues} />
        <PaymentDetails formValues={formValues} />
      </Grid> */}
      <Grid item xs={12} sm={6}>
        {/* <ShippingDetails formValues={formValues} rhf={rhf} /> */}

        {/* ปิดหน้าสรุปข้อมูลไว้ก่อน */}
        {/* <ShippingDetails rhf={rhf} /> */}
        
      </Grid>{' '}
      <Grid item xs={12} sm={6}>
        {/* <AddressDetails formValues={formValues} /> */}
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <PaymentDetails formValues={formValues} /> */}
      </Grid>
    </React.Fragment>
  );
}
